module.exports = __webpack_public_path__ + "assets/img/lingo.ee0da612.png";